<template>
  <div>
    <div>
      <label class="material-label" style="margin-bottom: 5px">{{ $t('componentList.extras') }}</label>
      <el-table
        ref="stockCorrectionList"
        v-loading="loading"
        :data="products"
        border
        fit
        highlight-current-row
        style="width: 100%"
      >
        <el-table-column :label="$t('stockCorrection.stockProductCode')">
          <template slot-scope="scope">
            <span>{{ scope.row['code'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.product')">
          <template slot-scope="scope">
            <span>{{ scope.row['productDescription'] }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.piecesAmount')">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['amount']) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.panelsAmount')">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['panelAmount']) }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('componentList.metersAmount')">
          <template slot-scope="scope">
            <span>{{ Math.ceil(scope.row['meterAmount']) }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ComponentListExtras',
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    products: {
      type: Array,
      default: () => []
    }
  }
};
</script>
